//ParcelSymbol.ts ==============================================================
import "../Util/Prototypes";

import * as Settings from "../Settings";
import * as Util_App from "../Util/Util_App";

import Color from "@arcgis/core/Color";

let prevBasemap: string = "";

//Set parcel symbology dark or light based on basemap.
export function setParcelSymbol(basemapName: string) {
   if (Settings.darkBasemapWords.length > 0) {

      if (basemapName !== prevBasemap) {
         let found: boolean = false;

         for (const darkWord of Settings.darkBasemapWords) {
            if (basemapName.Contains(darkWord)) {
               found = true;
               break;
            }
         }

         let newColor: number[] = Settings.forLightBasemap;
         if (found) {
            newColor = Settings.forDarkBasemap;
         }

         const layer = Util_App.getOperationalLayerById(Settings.parcelLayerName) as __esri.FeatureLayer;
         if (layer && layer.renderer) {
            const simpleRenderer = layer.renderer as __esri.SimpleRenderer;

            const renderer = simpleRenderer.clone();
            const polySym = renderer.symbol as __esri.SimpleFillSymbol;

            if (renderer.symbol && polySym.outline) {
               polySym.outline.color = Color.fromArray(newColor);
               layer.renderer = renderer;
            }
         }
         prevBasemap = basemapName;
      }
   }

} //End function.
